module.exports = __webpack_public_path__ + "img/phonetop.eeb0e161.png";